import React from "react";
import Knowledge from "./Knowledge";

const KnowledgePage = () => {
  return <Knowledge />;
};

export default KnowledgePage;

